import { useEffect, useState } from 'react';

// Разбираем start_param:
// - Если формат "key-value_key2-value2" -> объект { key: value, key2: value2 }
// - Если просто одиночный токен без разделителей -> { ref: 'ТОКЕН' }
const decodeStartParam = (raw) => {
  console.log('[useTelegram] raw start_param:', raw);

  if (!raw) return {};

  // Пробуем распарсить как key-value пары (promo-X_ref-Y)
  if (raw.includes('-') && raw.includes('_')) {
    const parsed = raw.split('_').reduce((acc, pair) => {
      const idx = pair.indexOf('-');
      if (idx === -1) return acc;
      const key = pair.slice(0, idx);
      const value = pair.slice(idx + 1);
      if (key) acc[key] = value;
      return acc;
    }, {});

    if (Object.keys(parsed).length > 0) {
      console.log('[useTelegram] parsed as key-value:', parsed);
      return parsed;
    }
  }

  // Иначе — это просто одиночный реферальный код
  console.log('[useTelegram] parsed as plain ref token:', raw);
  return { ref: raw };
};

export const useTelegram = () => {
  const [tg, setTg] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const app = window.Telegram?.WebApp;
    if (app) {
      app.ready();
      app.expand();
      app.setHeaderColor('#4A90E2');
      app.setBackgroundColor('#FFFFFF');
      app.disableClosingConfirmation();

      // 🔍 ДЕБАГ: смотрим что реально пришло от Telegram
      console.log('[useTelegram] initDataUnsafe:', app.initDataUnsafe);
      console.log('[useTelegram] initDataUnsafe.start_param:', app.initDataUnsafe?.start_param);
      console.log('[useTelegram] platform:', app.platform, 'version:', app.version);

      setTg(app);
      setUser(app.initDataUnsafe?.user);
    } else {
      console.log('[useTelegram] window.Telegram.WebApp отсутствует (не в Telegram)');
    }
  }, []);

  const onClose = () => {
    tg?.close();
  };

  const onToggleButton = () => {
    if (tg?.MainButton.isVisible) {
      tg.MainButton.hide();
    } else {
      tg.MainButton.show();
    }
  };

  const showMainButton = (text, onClick) => {
    if (tg?.MainButton) {
      tg.MainButton.setText(text);
      tg.MainButton.onClick(onClick);
      tg.MainButton.show();
    }
  };

  const hideMainButton = () => {
    tg?.MainButton.hide();
  };

  const showAlert = (message) => {
    //tg?.showAlert(message);
  };

  const showConfirm = (message, callback) => {
    //tg?.showConfirm(message, callback);
  };

  const hapticFeedback = (type = 'impact') => {
    if (tg?.HapticFeedback) {
      switch (type) {
        case 'impact':
          tg.HapticFeedback.impactOccurred('medium');
          break;
        case 'notification':
          tg.HapticFeedback.notificationOccurred('success');
          break;
        case 'selection':
          tg.HapticFeedback.selectionChanged();
          break;
        default:
          tg.HapticFeedback.impactOccurred('medium');
      }
    }
  };

  const startParam = decodeStartParam(tg?.initDataUnsafe?.start_param);
  console.log('[useTelegram] final startParam object:', startParam);

  return {
    tg,
    user,
    initData: tg?.initData,
    onClose,
    onToggleButton,
    showMainButton,
    hideMainButton,
    showAlert,
    showConfirm,
    hapticFeedback,
    queryId: tg?.initDataUnsafe?.query_id,
    startParam,
    isInTelegram: !!tg,
  };
};